import { render } from "./TableDetail.vue?vue&type=template&id=93fa47b2"
import script from "./TableDetail.vue?vue&type=script&lang=js"
export * from "./TableDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__